import React from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import "./AnimationHotAirBalloon2.css";

export default function AnimationHotAirBalloon2() {
  return (
    <div className="balloon2">
      <DotLottieReact
        src="https://lottie.host/fe443b9f-5e2a-4ef5-aaa2-04e0a31e22e3/GI1izLbEKX.lottie"
        autoplay
        height={100}
        width={100}
      />
    </div>
  );
}
